/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';
import cardStyle from './view-all-tile/view-all-tile.css';
import { renderHtml } from './utils/render-html';

const Body = ({
  title, shortDescription, children, isListView,
}) => (
  <div className="margin-2-t-sm-down">
    {title && <Heading level={3} variant="sans-xsmall-bold" className={`color-text-subtle ${isListView ? 'margin-1-b' : ''}`}>{renderHtml(title)}</Heading>}
    {children}
    {shortDescription && (
    <div className={`body-small color-text-subtle ${cardStyle.accordionDescription}`}>
      {renderHtml(shortDescription)}
    </div>
    )}
  </div>
);

Body.propTypes = {
  title: PropTypes.string.isRequired,
  shortDescription: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.bool,
  ]),
};

export default Body;
